import { useSchedulerSidebar } from '@contexts/scheduler/sidebar';
import { SchedulerSidebarConfirmCrewAssignment } from '@components/scheduler/sidebar/confirm/crewAssignment';
import { SchedulerSidebarConfirmCrewChanged } from '@components/scheduler/sidebar/confirm/crewChanged';
import { SchedulerSidebarConfirmEquipmentAssignment } from '@components/scheduler/sidebar/confirm/equipmentAssignment';
import { SchedulerSidebarConfirmEquipmentChanged } from '@components/scheduler/sidebar/confirm/equipmentChanged';
import { cn } from '@utils/cn';

const sheetClass =
  'flex max-h-[85dvh] flex-col overflow-y-auto rounded-t-2xl bg-white px-2 pb-[calc(12px+env(safe-area-inset-bottom,0px))] pt-2 shadow-[0_-8px_30px_rgba(0,0,0,.18)] ' +
  '[&>div]:border-t-0 [&>div]:p-2 [&_.flex.justify-end]:grid [&_.flex.justify-end]:grid-cols-2 [&_button]:h-11 [&_button]:text-sm ' +
  '[&_label_span]:text-sm [&_label]:py-1 [&_strong]:text-base [&_button[role=radio]]:h-5 [&_button[role=radio]]:w-5';

export const PhoneConfirmSheet = () => {
  const { confirm } = useSchedulerSidebar();
  const open =
    confirm?.crewAssignment.open ||
    confirm?.crewChanged.open ||
    confirm?.equipmentAssignment.open ||
    confirm?.equipmentChanged.open;

  return (
    <div
      aria-hidden={!open}
      className={cn(
        'absolute inset-0 z-[60] flex flex-col justify-end bg-[rgba(24,28,33,.45)]',
        !open && 'pointer-events-none invisible',
      )}>
      <div role="dialog" aria-modal={open} className={sheetClass}>
        <div className="mx-auto mb-1 h-1.5 w-10 shrink-0 rounded-full bg-neutral-200" />
        <SchedulerSidebarConfirmCrewAssignment />
        <SchedulerSidebarConfirmCrewChanged />
        {!confirm?.crewAssignment.open && <SchedulerSidebarConfirmEquipmentAssignment />}
        {!confirm?.crewChanged.open && <SchedulerSidebarConfirmEquipmentChanged />}
      </div>
    </div>
  );
};
